import './Sidebar.css';

const NAV_ITEMS = [
  { key: 'roles', label: 'Role Management', icon: '\u2699' },
  { key: 'pipeline', label: 'Stage & Template Builder', icon: '\u25B6' },
  { key: 'profiles', label: 'Profile Manager', icon: '\uD83D\uDC64' },
  { key: 'leads', label: 'Lead Management', icon: '\uD83C\uDFAF' },
  { key: 'prospects', label: 'Prospect Onboarding', icon: '\uD83D\uDCC8' },
  { key: 'clients', label: 'Client Journey', icon: '\uD83D\uDDFA\uFE0F' },
  { key: 'clientProfile', label: 'Client Profile', icon: '\uD83D\uDCCB' },
];

export default function Sidebar({ isOpen, onToggle, activePage, onNavigate }) {
  return (
    <aside className={`sidebar ${isOpen ? 'sidebar--open' : 'sidebar--collapsed'}`}>
      <div className="sidebar__brand">
        {isOpen && <span className="sidebar__brand-text">Gplanck CRM</span>}
        <button className="sidebar__toggle" onClick={onToggle}>
          {isOpen ? '\u2039' : '\u203A'}
        </button>
      </div>

      <nav className="sidebar__nav">
        {NAV_ITEMS.map(item => (
          <button
            key={item.key}
            className={`sidebar__nav-item ${activePage === item.key ? 'sidebar__nav-item--active' : ''}`}
            onClick={() => onNavigate(item.key)}
            title={!isOpen ? item.label : undefined}
          >
            <span className="sidebar__nav-icon">{item.icon}</span>
            {isOpen && <span className="sidebar__nav-label">{item.label}</span>}
          </button>
        ))}
      </nav>

      {isOpen && (
        <div className="sidebar__footer">
          <span className="sidebar__footer-text">Wealth CRM v2.0</span>
        </div>
      )}
    </aside>
  );
}
